class ColorToggle {
  constructor(classname) {
    this.classname = classname;
    this.body = document.body;
    this.colorHover = document.querySelectorAll(
      `${this.classname} a, ${this.classname} p a, ${this.classname} button, ${this.classname} input[type=submit], ${this.classname} input[type=file]`,
    );
    this.colorArray = ['#ff9c94', '#61eeb3', '#f5a5ff', '#b3b6fc'];
    this.colorIndex = 0;
    this.body.style.setProperty(
      '--color-toggle-hover',
      this.colorArray[Math.floor(Math.random() * this.colorArray.length)],
    );
    this.bindEvents();
  }

  bindEvents() {
    const colorHovers = Array.from(this.colorHover);
    if (colorHovers.length) {
      colorHovers.forEach(hover => {
        hover.addEventListener('mouseenter', this.toggleColor.bind(this));
      });
    }
  }

  toggleColor() {
    const currentColor = this.colorIndex < this.colorArray.length - 1 ? (this.colorIndex += 1) : 0;
    this.colorIndex = currentColor;
    this.body.style.setProperty('--color-toggle-hover', this.colorArray[currentColor]);
  }
}

export default ColorToggle;
